import React from 'react'
import {graphql, useStaticQuery} from 'gatsby'
import {GatsbyImage, getImage} from 'gatsby-plugin-image'
import {Col, Row} from 'react-bootstrap'

import ImageWithText from '../../components/ImageWithText'
import Section from '../../components/Section'

const PossibleComplications = () => {
  const {
    allFile: {nodes: images},
  } = useStaticQuery<Queries.PossibleComplicationsQuery>(query)

  const renderImage = (id: string, alt: string) => {
    const imageData = images.find((img) => img.name === id.toString()) || null
    const image = getImage(imageData?.childImageSharp?.gatsbyImageData || null)
    if (!image) return null
    return <GatsbyImage image={image} alt={alt} className={''} />
  }

  return (
    <Section
      id="possible-complications"
      background="purple"
      className="text-center"
    >
      <h2 className="fs-1 fw-bold mb-4">
        Possible
        <br className="d-lg-none" />
        <span className="d-none d-lg-inline"> </span>
        complications
      </h2>
      <p>
        If you develop a skin or lung infection, you may need treatment with
        antibiotics. In severe cases, you may need to be hospitalised.
      </p>
      <p>
        For people at high risk of complications, doctors sometimes prescribe
        medications to shorten the duration of the infection and reduce the risk
        of complications. These should be given within 24 hours of the first
        appearance of the rash.
      </p>

      <Row className="mx-2 mx-lg-none my-5 g-5">
        {data.map(({title, text, imgAlt}) => (
          <Col key={text} lg={4} className="h-100">
            <ImageWithText
              text={text}
              img={renderImage(title, imgAlt)}
              className="gap-4 px-lg-3"
              redCircle={false}
            />
          </Col>
        ))}
      </Row>

      <p className="fw-semibold">
        There may not always be signs of chickenpox complications. However, you
        should look out for swollen or painful skin, difficulty breathing or
        dehydration.
      </p>
      <p className="fw-semibold">
        If you see any possible signs of complications, contact your GP or NHS
        111 immediately.
      </p>
    </Section>
  )
}

export default PossibleComplications

const data = [
  {
    title: 'Guy',
    text: 'Infections caused by harmful bacteria getting into the skin, making it red, swollen and painful',
    imgAlt: 'Animated image of a child with a chickenpox rash',
  },
  {
    title: 'Woman',
    text: 'Problems during pregnancy, including the infection spreading to the unborn baby',
    imgAlt: 'Animated image of a pregnant lady',
  },
  {
    title: 'Girl',
    text: 'Lung infections (pneumonia), which can cause a persistent cough, breathing difficulties and chest pain',
    imgAlt: 'Animated image of a child coughing',
  },
]

const query = graphql`
  query PossibleComplications {
    allFile(
      filter: {
        relativeDirectory: {eq: "possible-complications"}
        extension: {ne: "svg"}
      }
    ) {
      nodes {
        name
        childImageSharp {
          gatsbyImageData(width: 150, transformOptions: {fit: CONTAIN})
        }
      }
    }
  }
`
